import { Link } from "react-router-dom";
import { useBranding } from "@/lib/branding";
import WorkspaceSwitcher from "@/components/WorkspaceSwitcher";
import UserMenu from "@/components/UserMenu";

export default function AppHeader() {
  const { branding, logoUrl } = useBranding();
  const primary = branding.primary_color || "#C5A880";
  const initial = (branding.firm_name || "I").trim().charAt(0).toUpperCase() || "I";

  return (
    <header
      className="fixed top-0 inset-x-0 z-40 backdrop-blur-xl bg-[#0A0C10]/80 border-b border-white/5"
      data-testid="app-header"
    >
      <div className="max-w-5xl mx-auto px-4 py-3 flex items-center justify-between gap-3">
        <Link to="/dashboard" className="flex items-center gap-2" data-testid="header-logo-link">
          {logoUrl ? (
            <img
              src={logoUrl}
              alt={branding.firm_name}
              className="w-8 h-8 rounded-lg object-cover border"
              style={{ borderColor: `${primary}99` }}
            />
          ) : (
            <div
              className="w-8 h-8 rounded-lg border flex items-center justify-center"
              style={{ borderColor: `${primary}99` }}
            >
              <span className="font-display font-bold text-sm" style={{ color: primary, letterSpacing: "-0.04em" }}>
                {initial}
              </span>
            </div>
          )}
          <div className="leading-tight hidden sm:block">
            <div className="font-display font-bold text-[15px] tracking-tight">
              {branding.firm_name}
            </div>
          </div>
        </Link>
        <div className="flex items-center gap-2">
          <WorkspaceSwitcher />
          <UserMenu />
        </div>
      </div>
    </header>
  );
}
